import type { FeatureToggles } from '@makemydeal/dr-platform-shared';
import type { AnyFSA } from '@makemydeal/dr-browser-utils';

import type { ReduxMiddleware, ReduxNext, ReduxStore } from '@makemydeal/dr-shared-store';
import { bootstrapActionTypes } from '@makemydeal/dr-shared-store';
import { payloadUtils } from '@makemydeal/dr-shared-ui-utils';
import type { ConfigChangeVehicle, MiddlewareManager } from '@makemydeal/dr-activities-change-vehicle';

import { configureChangeVehicle } from './config';
import { getServicesBff } from '../../selectors/salesCheckinAppSelectors';
import { APP_NAME } from '../../../../constants';

import type { SalesCheckinRootState } from '@makemydeal/dr-sales-checkin-store';

// keep a cached version of the middleware once we're able to build it.
// exported to support testing
export let cachedChangeVehicleMiddlewareMgr: MiddlewareManager | undefined;

// needed for testing
export const changeVehicleMiddlewareClearCache = () => (cachedChangeVehicleMiddlewareMgr = undefined);

export const changeVehicleMiddleware: ReduxMiddleware<SalesCheckinRootState> =
    (store: ReduxStore<SalesCheckinRootState>) => (next: ReduxNext) => (action: AnyFSA) => {
        switch (action.type) {
            case bootstrapActionTypes.BOOTSTRAP_SUCCESS: {
                // get what we can from state.  This typically will be the bff endpoint only since its placed as part of initial state
                const state = store.getState();
                const bff = getServicesBff(state);
                const featureToggles: FeatureToggles = payloadUtils.getFeatureTogglesFromInitPayload(action.payload);

                const initConfig: ConfigChangeVehicle = {
                    applicationName: APP_NAME,
                    hostApp: 'SCI',
                    services: {
                        bff
                    },
                    featureToggles
                };

                cachedChangeVehicleMiddlewareMgr = configureChangeVehicle(initConfig);

                break;
            }
        }

        if (cachedChangeVehicleMiddlewareMgr) {
            cachedChangeVehicleMiddlewareMgr.middleware(store)(next)(action);
        } else {
            next(action);
        }
    };
